'use client';

import { usePathname } from '@/i18n/navigation';
import GlobalTooltip from '@/components/layout/GlobalTooltip';

export default function GlobalTooltipGate() {
  return <GlobalTooltip />;
}
